import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import KanbanDashboard from "./pages/KanbanDashboard";
import SelectAlternatePage from "./pages/SelectAlternatePage";
import AddPaymentPage from "./pages/AddPaymentPage";
import SignAgreementPage from "./pages/SignAgreementPage";
import RentalAgreementPage from "./pages/RentalAgreementPage";
import MeetRentalRequestPage from "./pages/MeetRentalRequestPage";
import RentalRequestFormPage from "./pages/RentalRequestFormPage";
import UserDetailPage from "./pages/UserDetailPage";
import RentalDetailPage from "./pages/RentalDetailPage";
import PasswordGate from "./components/PasswordGate";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Default redirect to kanban */}
          <Route path="/" element={<Navigate to="/kanban" replace />} />
          
          {/* Main tabs - each has its own URL */}
          <Route path="/kanban" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="kanban" />
            </PasswordGate>
          } />
          <Route path="/rentals" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="rentals" />
            </PasswordGate>
          } />
          <Route path="/requests" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="requests" />
            </PasswordGate>
          } />
          <Route path="/checkins" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="checkins" />
            </PasswordGate>
          } />
          <Route path="/checkins/new" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="checkins" createMode={true} />
            </PasswordGate>
          } />
          <Route path="/users" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="users" />
            </PasswordGate>
          } />
          <Route path="/poles" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="poles" />
            </PasswordGate>
          } />
          <Route path="/transactions" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="transactions" />
            </PasswordGate>
          } />
          <Route path="/subscription-calendar" element={
            <PasswordGate>
              <KanbanDashboard defaultTab="subscription-calendar" />
            </PasswordGate>
          } />
          
          {/* Detail pages - wrapped in KanbanDashboard for nav */}
          <Route path="/users/:userId" element={
            <PasswordGate>
              <KanbanDashboard userId="fromUrl" />
            </PasswordGate>
          } />
          <Route path="/rentals/:rentalId" element={
            <PasswordGate>
              <KanbanDashboard rentalId="fromUrl" />
            </PasswordGate>
          } />
          
          {/* Public routes */}
          <Route path="/select-alternate" element={<SelectAlternatePage />} />
          <Route path="/add-payment" element={<AddPaymentPage />} />
          <Route path="/payment-complete" element={<AddPaymentPage />} />
          <Route path="/sign-agreement" element={<SignAgreementPage />} />
          <Route path="/rental-agreement" element={<RentalAgreementPage />} />
          <Route path="/meet-rental" element={<MeetRentalRequestPage />} />
          <Route path="/rental-request" element={<RentalRequestFormPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
